import type { Entitlements } from '@ims/data'

/** Days before the end of a free trial when the app starts reminding. */
export const TRIAL_REMINDER_DAYS = 14

/**
 * Whole days left in the free trial when it ends within the reminder window
 * (0 = ends today), else null (not on trial, or plenty of time left).
 */
export function trialDaysLeft(
  ent: Pick<Entitlements, 'status' | 'current_period_end'> | null | undefined,
  now: Date,
): number | null {
  if (ent?.status !== 'trialing' || !ent.current_period_end) return null
  const ms = new Date(ent.current_period_end).getTime() - now.getTime()
  if (ms < 0) return null
  const days = Math.floor(ms / 86_400_000)
  return days <= TRIAL_REMINDER_DAYS ? days : null
}
